export enum MediaType {
	LIVE = 'LIVE',
	VOD = 'PLAYBACK',
}
